import { Sort } from '../interfaces/sort';
import { Identifier } from './identifier';

export class SelectionPriority<T extends Record<string, any>>
  implements Sort<T>
{
  private keys: any[];

  constructor(
    public readonly items: T[],
    public readonly selections: T[],
    public readonly key: string
  ) {}

  build(): void {
    this.keys = this.selections.map((item) =>
      new Identifier(item, this.key).value()
    );
  }

  sort(): T[] {
    this.build();
    const [selected, unselected] = this.group();
    return [...selected, ...unselected];
  }

  group(): [T[], T[]] {
    const selected = [];
    const unselected = [];

    for (let item of this.items) {
      if (this.selected(item)) {
        selected.push(item);
        continue;
      }

      unselected.push(item);
    }

    return [selected, unselected];
  }

  selected(item: T): boolean {
    return this.keys.includes(new Identifier(item, this.key).value());
  }
}
